// extracted by mini-css-extract-plugin
export default {"confirm":"Confirm-module__confirm__WFrz8a9","copilotRun":"Confirm-module__copilotRun__p56VGq8"};